import React from 'react';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import List from '@mui/material/List';
import { CHILDREN_PROP_TYPES } from 'propTypes';

import LocationHeaderTypography from 'bento-ordering/locations/components/LocationHeaderTypography';
import { MENU_ITEM_NAMES } from 'styles/constants/appearanceSectionNames';

const LocationListSection = ({ children, title, dataTestId }) => {
  const styles = { variant: MENU_ITEM_NAMES };

  return (
    <Box mb={5} data-testid={dataTestId}>
      <Box mb={2.5}>
        <LocationHeaderTypography {...styles}>{title}</LocationHeaderTypography>
      </Box>

      <List>{children}</List>
    </Box>
  );
};

LocationListSection.propTypes = {
  children: CHILDREN_PROP_TYPES.isRequired,
  title: PropTypes.string.isRequired,
  dataTestId: PropTypes.string.isRequired
};

export default LocationListSection;
